
import TitleBox from '@/components/CSS/TitleBox'
import OrderBoxServe from '@/components/OrderBox/OrderBoxServe'

export default {
    components: {
        TitleBox,
        OrderBoxServe
    },
}
